import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
} from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  type ICustomReport,
  type ICustomReportFilter,
} from '@principle-theorem/principle-core/interfaces';
import {
  CustomReportFilter,
  REPORT_BUILDER_DATA_SOURCES,
  resolveDataSource,
} from '@principle-theorem/reporting';
import { QueryFilterDisplayComponent } from '../query-filter-display/query-filter-display.component';

@Component({
  selector: 'pr-pre-selected-filters',
  templateUrl: './pre-selected-filters.component.html',
  styleUrls: ['./pre-selected-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, QueryFilterDisplayComponent],
})
export class PreSelectedFiltersComponent {
  customReport = input.required<ICustomReport>();
  columnLayout = input(false);
  dataSource = computed(() =>
    resolveDataSource(
      this.customReport().dataSource,
      REPORT_BUILDER_DATA_SOURCES
    )
  );

  @HostBinding('class')
  get elementClass(): string {
    const direction = this.columnLayout() ? 'flex-col' : 'flex-row';
    const alignment = this.columnLayout() ? 'items-start' : 'items-center';
    return `flex ${direction} flex-wrap ${alignment} gap-1`;
  }

  getFilterSummary(filter: ICustomReportFilter): string {
    const factTable = this.dataSource()?.factTable;
    return factTable
      ? CustomReportFilter.getSummary(factTable, filter)
      : 'Unknown';
  }
}
